<template>
  <div class="boxall">
    <div class="title">农资集采</div>
    <div class="boxnav">
      <div class="bg-image"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FarmerCollect'
}
</script>

<style scoped>
.bg-image {
  width: 100%;
  height: 100%;
  background: url('../assets/images/collect_people.png') no-repeat center center;
  background-size: cover;
  border-radius: 0.15rem;

  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
</style>
